import React, { useState, useEffect } from "react";


const International = ({Module, slider_count, id}) => {

    return (
        <React.Fragment>

        </React.Fragment>
    );
};
export default International;
